import React from 'react';

import styles from './CommentCheckbox.module.scss';

type CommentCheckboxProps = React.ComponentPropsWithoutRef<'div'> & {
  checked: boolean;
};

export const CommentCheckbox = ({ checked, className, ...props }: CommentCheckboxProps) => (
  <div
    className={
      className ? `${styles['comment-checkbox']} ${className}` : styles['comment-checkbox']
    }
    data-checked={checked}
    {...props}
  />
);
